import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { cn } from '@achra/ui/lib/utils';
import { replaceAllNumberLetOneBeforeDot } from '../../../lib/expenses-metric-chart-utils';
import type { ExpensesMetricChartSeriesData } from '../../../types';
interface Props {
  element: ExpensesMetricChartSeriesData;
  onLegendItemHover: (legendName: string) => void;
  onLegendItemLeave: (legendName: string) => void;
  handleToggleSeries: (series: string) => void;
  className?: string;
  showLegendValue?: boolean;
  value?: number;
}
function ExpensesMetricChartItem(t0) {
  const $ = _c(27);
  const {
    element,
    onLegendItemHover,
    onLegendItemLeave,
    handleToggleSeries,
    className,
    showLegendValue: t1,
    value
  } = t0;
  const showLegendValue = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex h-fit w-fit cursor-pointer flex-row items-center justify-start gap-2 p-0", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== element.name || $[3] !== onLegendItemHover) {
    t3 = () => {
      onLegendItemHover(element.name);
    };
    $[2] = element.name;
    $[3] = onLegendItemHover;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== element.name || $[6] !== onLegendItemLeave) {
    t4 = () => {
      onLegendItemLeave(element.name);
    };
    $[5] = element.name;
    $[6] = onLegendItemLeave;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== element.name || $[9] !== handleToggleSeries) {
    t5 = () => {
      handleToggleSeries(element.name);
    };
    $[8] = element.name;
    $[9] = handleToggleSeries;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== element.itemStyle.colorOriginal) {
    t6 = <div data-slot="svg-container" className="flex items-center"><svg data-slot="legend-indicator" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13" fill="none" className="h-3 w-3 md:h-4 md:w-4"><circle cx="6.5" cy="6.5" r="5.5" stroke={element.itemStyle.colorOriginal} /><circle cx="6.5" cy="6.5" r="4" fill={element.itemStyle.colorOriginal} /></svg></div>;
    $[11] = element.itemStyle.colorOriginal;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn("text-foreground text-center text-xs leading-[18px] font-semibold", "md:w-fit md:max-w-[212px] md:overflow-hidden md:text-start md:text-sm md:leading-[22px] md:text-ellipsis md:whitespace-nowrap", "xl:max-w-[250px] xl:text-base xl:leading-[24px]");
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== element.name) {
    t8 = <div data-slot="legend-name" className={t7}>{element.name}</div>;
    $[14] = element.name;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== showLegendValue || $[17] !== value) {
    t9 = showLegendValue && <div data-slot="legend-value" className={cn("text-muted-foreground text-xs leading-[18px] font-semibold", "md:text-sm md:leading-[22px]", "xl:text-base xl:leading-[24px]")}>{replaceAllNumberLetOneBeforeDot(value ?? 0, true)}</div>;
    $[16] = showLegendValue;
    $[17] = value;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t8 || $[25] !== t9) {
    t10 = <Button variant="ghost" data-slot="legend-item-container" className={t2} onMouseEnter={t3} onMouseLeave={t4} onClick={t5}>{t6}{t8}{t9}</Button>;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}
export { ExpensesMetricChartItem };